export default __webpack_public_path__ + "static/media/img3.193a26d7.jpg";